import './NavigationDropdownContent.css';

import { CSSProperties } from 'react';
import { useBreakpoints } from '@cbhq/cds-web/hooks/useBreakpoints';
import { VStack } from '@cbhq/cds-web/layout';

import { CONTENT_WIDTH } from '../Organization/constants';

const resourceListStyle: CSSProperties = {
  overflowY: 'auto',
  overflowX: 'hidden',
  scrollbarWidth: 'thin',
};

const hiddenScrollbarResourceListStyle: CSSProperties = {
  ...resourceListStyle,
  scrollbarWidth: 'none',
};

type NavigationDropdownContentProps = {
  children: React.ReactNode;
  maxHeight?: CSSProperties['maxHeight'];
  hideScrollbar?: boolean;
};

export function NavigationDropdownContent({
  children,
  maxHeight,
  hideScrollbar = false,
}: NavigationDropdownContentProps) {
  const { isPhone } = useBreakpoints();

  return (
    <VStack
      className={hideScrollbar ? 'identityNavigationHiddenScrollbar' : undefined}
      width={isPhone ? '100%' : CONTENT_WIDTH}
      maxHeight={maxHeight}
      style={hideScrollbar ? hiddenScrollbarResourceListStyle : resourceListStyle}
    >
      {children}
    </VStack>
  );
}
